export const PAYMENT_TYPE_LIST = [
    { value: "BILL_PAY_SINGLE_LINE", label: "Postpay single line" },
    { value: "BILL_PAY_MULTI_LINE", label: "Postpay multi line" },
    { value: "PAYG_REGISTERED", label: "Prepay registered" },
    { value: "PAYG_UNREGISTERED", label: "Prepay unregistered" },
];
